<template>
    <div>
      <div class="row" v-show="showClassifyWithoutAttributeError" id="attribute-not-set-description">
          <small class="text-danger" :class="{ 'col-md-6': size === 'sm', 'col-md-9': size === 'lg', 'offset-md-2': size === 'sm', 'offset-md-3': size === 'lg' }">
              Należy wybrać atrybut do klasyfikacji.
          </small>
      </div>
      <div class="form-group row">
          <label for="unique-value-attribute" class="control-label col-form-label" :class="{ 'col-md-2': size === 'sm', 'col-md-3': size === 'lg'}">Atrybut</label>
          <div :class="{ 'col-sm-6': size === 'sm', 'col-sm-7': size === 'lg'}">
              <b-form-select v-model="selectedAttribute" :options="attributesToSelect" class="mb-3" id="unique-value-attribute" :class="{ 'is-invalid': showClassifyWithoutAttributeError }" aria-required="true" :aria-invalid="showClassifyWithoutAttributeError" :aria-describedby="showClassifyWithoutAttributeError ? 'attribute-not-set-description' : ''"></b-form-select>                 
          </div>
          <div class="col-sm-1">
            <b-btn variant="primary" v-on:click="classify">Klasyfikuj</b-btn>
          </div>
      </div>
      <div v-if="selectedAttributeManyValues === true">
        <b-alert show variant="warning"><strong>Uwaga.</strong> Wybrany atrybut posiada wiele unikalnych wartości.</b-alert>
      </div>
      <div v-if="selectedAttributeTooManyValues === true">
        <b-alert show variant="warning"><strong>Uwaga.</strong> Wybrany atrybut posiada zbyt wiele unikalnych wartości. Wartości zostały ograniczone do 1024.</b-alert>
      </div>
      <div class="table-responsive" v-if="elementsCount !== 0">
        <table class="table table-striped">
          <thead>
              <tr>
                <th>Wartość</th>
                <th>Kształt</th>
                <th>Wielkość kształtu</th>
                <th>Kolor wypełnienia</th>
                <th>Styl obrysu</th>
                <th>Szerokość obrysu</th>
                <th>Kolor obrysu</th>
                <th>Ikona</th>
                <th>Akcje</th>
              </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in attributeUniqueValues" :key="row.name + index">
              <td>{{ getNameFromAttributes(row.name) }}</td>
              <td><b-form-select v-model="row.shape" :options="shapesList" size="sm" @input="row.icon = (row.shape ? null : row.icon)"></b-form-select></td>
              <td>
                <span v-show="row.styleDataErrors.shapeSizeEmpty" :id="'shape-size-empty-description-' + index">
                  <small class="text-danger">
                      Należy podać wielkość kształtu.
                  </small>
                </span>
                <span v-show="row.styleDataErrors.shapeSizeNotInRange" :id="'shape-size-range-description-' + index">
                  <small class="text-danger">
                      Wielkość kształtu powinna zawierać się w przedziale od 1 do 255.
                  </small>
                </span>
                <b-form-input v-model="row.shapeSize" type="number" min="1" max="255" size="sm" class="form-control" :class="{ 'is-invalid': row.styleDataErrors.shapeSizeEmpty || row.styleDataErrors.shapeSizeNotInRange }" aria-required="true" :aria-invalid="row.styleDataErrors.shapeSizeEmpty || row.styleDataErrors.shapeSizeNotInRange" :aria-describedby="row.styleDataErrors.shapeSizeEmpty ? 'shape-size-empty-description-' + index : (row.styleDataErrors.shapeSizeNotInRange ? 'shape-size-range-description-' + index : '')"></b-form-input>
              </td>
              <td><color-picker v-model="row.fillColor" size="sm" /></td>
              <td><b-form-select v-model="row.strokeStyle" :options="strokeStylesList" size="sm"></b-form-select></td>
              <td>
                <span v-show="row.styleDataErrors.strokeSizeEmpty" :id="'stroke-size-empty-description-' + index">
                  <small class="text-danger">
                      Należy podać szerokość obrysu.
                  </small>
                </span>
                <span v-show="row.styleDataErrors.strokeSizeNotInRange" :id="'stroke-size-range-description-' + index">
                  <small class="text-danger">
                      Szerokość obrysu powinna zawierać się w przedziale od 1 do 255.
                  </small>
                </span>
                <b-form-input v-model="row.strokeSize" type="number" min="1" max="255" size="sm" class="form-control" :class="{ 'is-invalid': row.styleDataErrors.strokeSizeEmpty || row.styleDataErrors.strokeSizeNotInRange }" :aria-required="row.strokeStyle !== null" :aria-invalid="row.styleDataErrors.strokeSizeEmpty || row.styleDataErrors.strokeSizeNotInRange" :aria-describedby="row.styleDataErrors.strokeSizeEmpty ? 'stroke-size-empty-description-' + index : (row.styleDataErrors.strokeSizeNotInRange ? 'stroke-size-range-description-' + index : '')"></b-form-input>
              </td>
              <td><color-picker v-model="row.strokeColor" size="sm" /></td>
              <td>
                <span v-show="row.styleDataErrors.iconIsEmpty" :id="'icon-is-empty-description' + index">
                  <small class="text-danger">
                      Należy wybrać ikonę lub kształt.
                  </small>
                </span>
                <icon-picker v-model="row.icon" size="sm" v-if="row.shape === null" :class="{ 'is-invalid': row.styleDataErrors.iconIsEmpty }" :aria-required="row.shape === null" :aria-invalid="row.styleDataErrors.iconIsEmpty" :aria-describedby="row.styleDataErrors.iconIsEmpty ? 'icon-is-empty-description-' + index : ''" :type="iconPickerType"/><span v-if="row.shape !== null">-</span>
              </td>
              <td class="text-center"><a href="#" title="Usuń" @click="deleteRow(row)"><span class="oi oi-trash"></span></a></td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-row align-v="center" v-if="elementsCount > 20">
        <b-col cols="4">
          Elementów na stronie: {{ elementsOnPageStart }} - {{ elementsOnPageEnd }} / {{ elementsCount }}
        </b-col>
        <b-col cols="8">
          <b-pagination align="right" :total-rows="elementsCount" :per-page="elementsPerPage" @input="changePage">
          </b-pagination>
        </b-col>
      </b-row>
      <div v-if="selectedUniqueValueAttribute === null">
        <b-alert show variant="info"><strong>Informacja.</strong> Nie wybrano żadnego atrybutu.</b-alert>
      </div>
      <div v-if="selectedAttributeEmptyValues === true">
        <b-alert show variant="warning"><strong>Uwaga.</strong> Wybrany atrybut nie ma unikalnych wartości.</b-alert>
      </div>
      <error-modal ref="errorModal"></error-modal>
      <loading-overlay :active.sync="loading" :is-full-page="true"></loading-overlay>
    </div>
</template>

<script>
import ColorPicker from "../../ColorPicker.vue";
import IconPicker from "../../IconPicker.vue";
import ErrorModal from "../../ErrorModal.vue";
import { Api as ApiStyle } from "../../../api/api-style.js";
import { getTimestamp, getRandomColor } from "../../../api/HelperFunctions";
import LayerStyleStore from "../store/LayerStyleStore";
import LoadingOverlay from "vue-loading-overlay";
import VueScrollTo from 'vue-scrollto';

export default {
  name: "FormLayerStylePointUniqueValue",
  props: {
    attributes: Array,
    layerId: String,
    size: String,
    iconPickerType: String,
  },
  data() {
    return {
      attributesToSelect: [],
      selectedAttribute: null,
      selectedUniqueValueAttribute: null,
      selectedAttributeEmptyValues: false,
      selectedAttributeTooManyValues: false,
      attributeUniqueValues: [],
      shapesList: [
        { text: "Wybierz", value: null },
        { text: "Kółko", value: "circle" },
        { text: "Kwadrat", value: "square" },
        { text: "Trójkąt", value: "triangle" },
        { text: "Gwiazdka", value: "star" },
        { text: "Krzyżyk", value: "cross" }
      ],
      strokeStylesList: [
        { text: "Wybierz", value: null },
        { text: "Kreskowany", value: [4, 4] },
        { text: "Kropkowany", value: [1, 1] },
        { text: "Ciągły", value: [1] }
      ],
      lastRequestTimestamp: null,
      showClassifyWithoutAttributeError: false,
      currentPage: 1,
      elementsPerPage: 20,
      elementsCount: 0,
      loading: false
    };
  },
  computed: {
    elementsOnPageStart() {
      return ((this.currentPage - 1) * this.elementsPerPage) + (this.attributeUniqueValues.length ? 1 : 0);
    },
    elementsOnPageEnd() {
      return ((this.currentPage -1) * this.elementsPerPage) + this.attributeUniqueValues.length;
    },
    selectedAttributeManyValues() {
      return !this.selectedAttributeTooManyValues && this.elementsCount > 128;
    }
  },
  mounted() {
    //Przypisanie atrybutów warstwy do wyboru.
    this.attributesToSelect = [];
    this.attributesToSelect.push({ text: "Wybierz", value: null });
    if (this.attributes !== null) {
      for (let i = 0; i < this.attributes.length; ++i) {
        this.attributesToSelect.push({
          text: this.attributes[i].name ? this.attributes[i].name : this.attributes[i].description,
          value: this.attributes[i].key
        });
      }
    }
    //Pobranie danych z obiektu przechowującego style.
    let store = new LayerStyleStore();
    const initialValue = store.getPointUniqueValue();
    if (initialValue != null && initialValue.reguly !== undefined && initialValue.reguly.length !== 0) {
      let buffer = store.getPointUniqueValueBuffer();
      for (let i = 0; i < initialValue.reguly.length; ++i) {
        if (i === 0) {
          this.selectedAttribute = initialValue.reguly[i].filtr.atrybut;
          this.selectedUniqueValueAttribute = initialValue.reguly[i].filtr.atrybut;
        }
        buffer.push({
          name: initialValue.reguly[i].filtr.wartosc,
          icon: initialValue.reguly[i].sygnatura.punkt.ikona,
          shape: initialValue.reguly[i].sygnatura.punkt.ksztalt,
          shapeSize: initialValue.reguly[i].sygnatura.punkt.rozmiar,
          fillColor: initialValue.reguly[i].sygnatura.wypelnienie.kolor,
          strokeStyle: initialValue.reguly[i].sygnatura.obrys.kreskowanie,
          strokeSize: initialValue.reguly[i].sygnatura.obrys.szerokosc,
          strokeColor: initialValue.reguly[i].sygnatura.obrys.kolor,
          styleDataErrors: {
            iconIsEmpty: false,
            shapeSizeEmpty: false,
            shapeSizeNotInRange: false,
            strokeSizeEmpty: false,
            strokeSizeNotInRange: false
          }
        });
      }
    }
    this.setUniqueValuesReactive();
    this.setTooltips();
  },
  updated() {
    this.setSortTooltips();
  },
  watch:{
    selectedUniqueValueAttribute: function(value) {
        if(value===null){
          VueScrollTo.scrollTo({container:'body',easing: "ease"});
        }
      },
    selectedAttributeEmptyValues: function(value) {
        if(value){
          VueScrollTo.scrollTo({container:'body',easing: "ease"});
        }
      }
  },
  methods: {
    classify() {
      if (this.selectedAttribute !== null) {
        this.loading = true;
        this.showClassifyWithoutAttributeError = false;
        this.selectedAttributeTooManyValues = false;
        var vm = this;
        this.selectedAttributeEmptyValues = false;
        this.selectedUniqueValueAttribute = this.selectedAttribute;
        let store = new LayerStyleStore();
        this.lastRequestTimestamp = getTimestamp();
        var api = new ApiStyle();    
        api
          .getWartosci({
            control: vm.lastRequestTimestamp,
            field: vm.selectedUniqueValueAttribute,
            layer: vm.layerId
          })
          .then(function(response) {
            vm.showError(false, null);
            if (response.body.control === vm.lastRequestTimestamp.toString()) {
              if(response.body.status === 'overflow'){
                vm.selectedAttributeTooManyValues = true;
              }
              let buffer = store.getPointUniqueValueBuffer();
              buffer.clear();
              if (response.body.unique_values.length !== 0) {
                for (var i = 0; i < response.body.unique_values.length; ++i) {
                  var color = getRandomColor();
                  buffer.push({
                    name: response.body.unique_values[i],
                    icon: null,
                    shape: "circle",
                    shapeSize: 12,
                    fillColor: color,
                    strokeStyle: [1],
                    strokeSize: 3,
                    strokeColor: color,
                    styleDataErrors: {
                      iconIsEmpty: false,
                      shapeSizeEmpty: false,
                      shapeSizeNotInRange: false,
                      strokeSizeEmpty: false,
                      strokeSizeNotInRange: false
                    }
                  });
                }
              } else {
                vm.selectedAttributeEmptyValues = true;
              }
              vm.setUniqueValuesReactive();
            }
          })
          .catch(function(err) {
            vm.showError(true, 'Podczas klasyfikacji wystąpił błąd. Spróbuj ponownie później.');
          }).finally(function(){
            setTimeout(() => { vm.loading = false; }, 0);
          });
      } else {
        this.showClassifyWithoutAttributeError = true;
      }
    },
    deleteRow(entry) {
      if (this.attributeUniqueValues != null) {
        let store = new LayerStyleStore();
        let buffer = store.getPointUniqueValueBuffer();
        buffer.remove(entry);
        this.setUniqueValuesReactive();
      }
    },
    updateValue() {
      let emitValue = {
        reguly: []
      };
      let store = new LayerStyleStore();
      let buffer = store.getPointUniqueValueBuffer();
      for (let i = 0; i < buffer.count(); ++i) {
        const bufferItem = buffer.get(i);
        emitValue.reguly.push({
          filtr: {
            atrybut: this.selectedUniqueValueAttribute,
            wartosc: bufferItem.name
          },
          sygnatura: {
            obrys: {
              kolor: bufferItem.strokeColor,
              kreskowanie: bufferItem.strokeStyle,
              szerokosc: bufferItem.strokeSize ? parseInt(bufferItem.strokeSize) : null
            },
            punkt: {
              ikona: bufferItem.icon,
              ksztalt: bufferItem.shape,
              rozmiar: bufferItem.shapeSize ? parseInt(bufferItem.shapeSize) : null
            },
            wypelnienie: {
              kolor: bufferItem.fillColor
            }
          }
        });
      }
      store.setPointUniqueValue(emitValue);
      this.$emit('updated');
    },
    setUniqueValuesReactive() {
      let store = new LayerStyleStore();
      let buffer = store.getPointUniqueValueBuffer();
      if(buffer.any()) {
        const currentIndex = (this.currentPage - 1) * this.elementsPerPage;
        this.attributeUniqueValues = buffer.get(currentIndex, currentIndex + this.elementsPerPage);
        this.elementsCount = buffer.count();
      } else {
        this.attributeUniqueValues = [];
        this.elementsCount = 0;
      }
    },
    changePage(value) {
      this.currentPage = value;
      this.setUniqueValuesReactive();
    },
    validate() {
      this.updateValue();
      var vm = this;
      let store = new LayerStyleStore();
      let buffer = store.getPointUniqueValueBuffer();
      let bufferArray = buffer.get();
      bufferArray.forEach(x =>
        Object.keys(x.styleDataErrors).forEach(
          y => (x.styleDataErrors[y] = false)
        )
      );
      this.showClassifyWithoutAttributeError = false;
      if(buffer.count() !== 0){
        for (let i = 0; i < buffer.count(); ++i) {
          const bufferItem = buffer.get(i);
          if (bufferItem.shape === null && bufferItem.icon === null) {
            bufferItem.styleDataErrors.iconIsEmpty = true;
          }
          if (bufferItem.shapeSize === "") {
            bufferItem.styleDataErrors.shapeSizeEmpty = true;
          } else if (parseInt(bufferItem.shapeSize) < 1 || parseInt(bufferItem.shapeSize) > 255) {
            bufferItem.styleDataErrors.shapeSizeNotInRange = true;
          }
          if (bufferItem.strokeStyle !== null) {
            if (bufferItem.strokeSize === "") {
              bufferItem.styleDataErrors.strokeSizeEmpty = true;
            } else if (parseInt(bufferItem.strokeSize) < 1 || parseInt(bufferItem.strokeSize) > 255) {
              bufferItem.styleDataErrors.strokeSizeNotInRange = true;
            }
          }
          buffer.set(bufferItem, i);
        }
        this.setUniqueValuesReactive();
      } else {
        this.showClassifyWithoutAttributeError = true;
      }
      return this.showClassifyWithoutAttributeError || bufferArray.some(x =>
        Object.keys(x.styleDataErrors).some(y => x.styleDataErrors[y] === true)
      );
    },
    showError(show, errorMessage) {
      if(this.size === 'lg' || show === false){
        this.$emit('errorMessage', { show: show, errorMessage: errorMessage });
      } else {
        this.$refs.errorModal.show(errorMessage);
      }
    },
    setTooltips() {
      var paginationButtons = Array.from(document.getElementsByClassName("page-item"));

      var firsts = paginationButtons.filter(pb => pb.innerText.indexOf("«") != -1);
      var previous = paginationButtons.filter(pb => pb.innerText.indexOf("‹") != -1);
      var nexts = paginationButtons.filter(pb => pb.innerText.indexOf("›") != -1);
      var lasts = paginationButtons.filter(pb => pb.innerText.indexOf("»") != -1);

      firsts.forEach(item => item.title = "Pierwsza");
      previous.forEach(item => item.title = "Poprzednia");
      nexts.forEach(item => item.title = "Następna");
      lasts.forEach(item => item.title = "Ostatnia");
    },
    setSortTooltips() {
      var sortButtons = Array.from(document.getElementsByClassName("sorting"));
      sortButtons.forEach(item => item.title = "Sortuj");
    },
    getNameFromAttributes(name) {
      if(this.attributes && this.selectedAttribute && this.selectedAttribute !== "") {
        const attribute = this.attributes.find(x => {
          return x.key.toLowerCase() === this.selectedAttribute.toLowerCase();
        })
        if(attribute && attribute.dictionary) {
          const translatedName = attribute.dictionary.find(x => {
            return x.litera === name;
          });
          if(translatedName && translatedName.wartosc) {
            return translatedName.wartosc;
          }
        }
      }
      return name;
    }
  },
  components: {
    ColorPicker,
    IconPicker,
    ErrorModal,
    LoadingOverlay,
    VueScrollTo
  }
};
</script>